exports.components = {
  "component---src-templates-404-404-js": () => import("./../../../src/templates/404/404.js" /* webpackChunkName: "component---src-templates-404-404-js" */),
  "component---src-templates-sustainability-index-js": () => import("./../../../src/templates/Sustainability/index.js" /* webpackChunkName: "component---src-templates-sustainability-index-js" */),
  "component---src-templates-sustainability-post-index-js": () => import("./../../../src/templates/SustainabilityPost/index.js" /* webpackChunkName: "component---src-templates-sustainability-post-index-js" */)
}

